import gql from "graphql-tag";
import { USER_ENTITY_FRAGMENT } from "@/graphql/accounts/fragments.js";

export const CREATE_USER_MUTATION = gql`
  mutation createUserMutation(
    $name: String!
    $email: String!
    $role: Role!
    $password: String!
  ) {
    createUser(name: $name, email: $email, role: $role, password: $password) {
      messages {
        field
        code
        message
      }
      result {
        ...UserEntity
      }
      successful
    }
  }
  ${USER_ENTITY_FRAGMENT}
`;

export const UPDATE_USER_MUTATION = gql`
  mutation updateUserMutation($id: ID!, $name: String, $email: String!) {
    updateUser(id: $id, name: $name, email: $email) {
      messages {
        field
        code
        message
      }
      result {
        ...UserEntity
      }
      successful
    }
  }
  ${USER_ENTITY_FRAGMENT}
`;

export const UPDATE_USER_ROLE_MUTATION = gql`
  mutation updateUserRoleMutation($id: ID!, $role: Role!) {
    updateUserRole(id: $id, role: $role) {
      messages {
        field
        code
        message
      }
      result {
        ...UserEntity
      }
      successful
    }
  }
  ${USER_ENTITY_FRAGMENT}
`;

export const DELETE_USER_MUTATION = gql`
  mutation deleteUserMutation($id: ID!) {
    deleteUser(id: $id) {
      messages {
        field
        code
        message
      }
      result {
        ...UserEntity
      }
      successful
    }
  }
  ${USER_ENTITY_FRAGMENT}
`;

export const CREATE_EMPLOYEE_MUTATION = gql`
  mutation createEmployeeMutation(
    $email: String!
    $firstName: String!
    $lastName: String!
    $employeeRef: String!
    $title: String
    $accountRef: String
    $departmentName: String
    $departmentRef: String
    $groupName: String
    $groupRef: String
    $crewName: String
    $crewRef: String
    $supervisorEmployeeRef: String
    $phoneNumber: String
    $roleName: String
    $rcNumber: String
    $level: String
    $roleRef: String
  ) {
    createEmployee(
      email: $email
      firstName: $firstName
      lastName: $lastName
      employeeRef: $employeeRef
      title: $title
      accountRef: $accountRef
      departmentName: $departmentName
      departmentRef: $departmentRef
      groupName: $groupName
      groupRef: $groupRef
      crewName: $crewName
      crewRef: $crewRef
      supervisorEmployeeRef: $supervisorEmployeeRef
      phoneNumber: $phoneNumber
      roleName: $roleName
      rcNumber: $rcNumber
      level: $level
      roleRef: $roleRef
    ) {
      successful
      messages {
        field
        message
      }
    }
  }
`;
